import React from 'react';
import SimpleTooltip from '../../../common/tooltip/SimpleTooltip';
import { connect } from 'react-redux';
import { showHideExcel } from './../reducer';

class Excel extends React.Component {
  onClick = () => {
    const { showHideExcel } = this.props;

    showHideExcel(true);
  };

  render() {
    return (
      <li>
        <SimpleTooltip
          message={'layout.tooltipSideBar.DOWNLOAD_EXCEL_FORMAT'}
          position={'right'}
          isI18n={true}
          appendClassName={'d-block'}
          appendStyle={{ zIndex: 99999 }}
        >
          <a href="#" onClick={this.onClick}>
            <i className="icon-excel" />
          </a>
        </SimpleTooltip>
      </li>
    );
  }
}

const mapDispatchToProps = {
  showHideExcel,
};

export default connect(
  null,
  mapDispatchToProps,
)(Excel);
